class BlogPosts {
  constructor() {
    this.items = document.querySelectorAll('.blog-posts__item');
    this.init();
  }

  init() {
    if (this.items.length) {
      this.initPostClick();
    }
  }

  initPostClick() {
    this.items.forEach((item) => {
      item.addEventListener('click', (e) => {
        if (e.target.closest('a')) {
          return;
        }

        const postUrl = item.getAttribute('data-post-url');
        if (postUrl) {
          window.location.href = postUrl;
        }
      });

      item.style.cursor = 'pointer';
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new BlogPosts();
});
